import Main from './pages/Main'
import { Route, Routes, useLocation } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import Admin from './private/editors/PageEditor'
// import Info from './pages/Info'
import NotFound from './pages/404'
import Nav from './ui/Nav'
import Footer from './ui/Footer'
import FormSuccess from './pages/Success'
import PrivacyPolicy from './legal/PrivacyPolicy'
import Cookies from './legal/Cookies';
import { useState } from 'react';
import PageRenderer from './pages/templates/PageTemplate'
import NavigationEditor from './private/editors/NavOrderEditor'
import ColorEditor from './private/editors/DefaultColorEditor'
import SyncFromTemplate from './private/demo/SyncNewPage'
// src/components/AdminFloatingButton.jsx
import { Analytics } from "@vercel/analytics/react"
import AdminFloatingButton from './button'
import Tutorial from './admin/Tutorial'
import { IS_DEMO } from './App';
import Login from './private/auth/Login'
import TrackerAdmin from './private/demo/Tracking'
import ResetPassword from './private/auth/ChangePasswd'

function LoadingAnimation() {
    const [cookiesConsent, setCookiesConsent] = useState(() => localStorage.getItem("cookiesConsent"));
    const location = useLocation()
    const resetCookiesConsent = () => {
    localStorage.removeItem("cookiesConsent");
    setCookiesConsent(null);
};

    // Scroll to top AFTER animation
    const handleExitComplete = () => {
        // Wait 1s after exit animation (adjust this to match your exit duration)
        setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'instant' })
        }, 100)
    }

    return (
        <>
           {!location.pathname.includes('/nawigacja') && <Nav key="nav" />}
           <Analytics/>
                <Cookies consent={cookiesConsent} setConsent={setCookiesConsent} />
                <AnimatePresence mode="wait" onExitComplete={handleExitComplete}>
                    <Routes location={location} key={location.pathname}>
                        <Route path="/" element={<Main/>} />
                        <Route path="/:name" element={<Main/>} />
                        <Route path="/:name/admin" element={<Admin/>} />
                        <Route path="/:name/admin/edytor/nawigacja" element={<NavigationEditor/>} />
                        <Route path="/:name/admin/edytor/kolor" element={<ColorEditor/>} />
                        <Route path="/:name/login" element={<Login/>} />
                        <Route path="/:name/admin/zmien-haslo" element={<ResetPassword/>} />
                        <Route path="/admin/" element={<Admin />} />
                        <Route path="/admin/sync" element={<SyncFromTemplate />} />
                        <Route path="/admin/tracker" element={<TrackerAdmin />} />
                        <Route path="/sukces" element={<FormSuccess />} />
                        <Route path="/prywatnosc" element={<PrivacyPolicy />} />
                        <Route path="/:name/:pageId" element={<PageRenderer />} />
                        <Route path="/:pageId" element={<PageRenderer />} />
                        <Route path="/:name/admin/tutorial" element={<Tutorial />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </AnimatePresence>   
                {IS_DEMO && <AdminFloatingButton />}
            <Footer key='footerpanel' onResetCookies={resetCookiesConsent} />
        </>
    )
}

export default LoadingAnimation
